export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },

    value: {
      type: String,
      default: undefined
    }
  },

  methods: {
    fromValue(value) {
      if (value === undefined || value === null) {
        return value;
      }

      if (this.ignoreEmpty && value === '') {
        // console.log('ignoreEmpty');
        value = undefined;
      }

      // console.log('Returning', value);
      return value;
    },

    filesChanged(evt) {
      // console.log('filesChanged', evt);
      this.$emit('input', evt);
    }
  }
}
